import { call, put, takeLatest } from 'redux-saga/effects'
import { select } from '@redux-saga/core/effects'
import { setWitnessSignature } from '../store/signatures.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { SignaturesConstants } from '../store/signatures.constants'
import { IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* getWitnessSignature() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrId: string = yield select(getPcrIdSelector)

  if (!pcrId) {
    return
  }
  try {
    const pcr: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)
    if (pcr._attachments) {
      if (pcr._attachments.StandardSignatures_Section1_Witness !== undefined) {
        const witnessSignature = pcr._attachments.StandardSignatures_Section1_Witness
        const signature = document.createElement('img')
        signature.src = 'data:' + witnessSignature.fileExtension + ';base64,' + witnessSignature.data
        yield put(setWitnessSignature(signature.src))
      } else {
        yield put(setWitnessSignature(null))
      }
    } else {
      yield put(setWitnessSignature(null))
    }
  } catch (e) {
    yield put(throwPcrException(`getWitnessSignature() error: ${e}`))
  }
}

export function* getWitnessSignatureSaga() {
  yield takeLatest([SignaturesConstants.GET_SIGNATURES], performWithMutexHOG, getWitnessSignature)
}
